import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {CircleCheck, CircleXmark} from '@gravity-ui/icons';
import {Card, Checkbox, Radio, Text} from '@gravity-ui/uikit';
import {QuestionType} from 'common/constants/survey';
import i18n from 'ui/i18n';

import VisuallyHidden from '../VisuallyHidden';

import {AnswerOptionProps} from './AnswerOption.types';

import './AnswerOption.scss';

const cnAnswerOption = cn('AnswerOption');

const AnswerOption: FC<AnswerOptionProps> = ({type, text, correct, selected}) => {
    const content = (
        <Text variant="body-2" className={cnAnswerOption('Text')} as="div">
            {text}
        </Text>
    );
    return (
        <Card className={cnAnswerOption()} size="m">
            {type === QuestionType.Checkbox && (
                <Checkbox
                    checked={selected}
                    size="l"
                    className={cnAnswerOption('Control')}
                    content={content}
                    controlProps={{'aria-hidden': true}}
                />
            )}
            {[QuestionType.Radio, QuestionType.OneRow, QuestionType.Stars].includes(type) && (
                <Radio
                    value=""
                    checked={selected}
                    size="l"
                    className={cnAnswerOption('Control')}
                    content={content}
                    controlProps={{'aria-hidden': true}}
                />
            )}
            {type === QuestionType.String && content}
            {correct ? (
                <>
                    <CircleCheck
                        className={cnAnswerOption('Icon', {correct})}
                        aria-hidden="true"
                        focusable="false"
                    />
                    <VisuallyHidden>{i18n('success-page', 'sr-answer-correct')}</VisuallyHidden>
                </>
            ) : (
                <>
                    <CircleXmark
                        className={cnAnswerOption('Icon')}
                        aria-hidden="true"
                        focusable="false"
                    />
                    <VisuallyHidden>{i18n('success-page', 'sr-answer-incorrect')}</VisuallyHidden>
                </>
            )}
        </Card>
    );
};
export default AnswerOption;
